<template>
  <div class="banquet-apply">
    <inputField
      id="name"
      label="姓名"
      placeholder="請輸入"
      inputType="name"
      maxLength="50"
      class="banquet-name"
      :value="displayInfo.name"
      @onInput="onInput($event)"
      :errorText="errorText.name"
    />
    <inputField
      id="phone"
      label="手機號碼/聯絡電話"
      placeholder="請輸入"
      inputType="phone"
      maxLength="11"
      class="banquet-phone"
      :value="displayInfo.phone"
      @onInput="onInput($event)"
      :errorText="errorText.phone"
    />
    <div class="banquet-apply-people-infos">
      <div
        class="banquet-apply-people-infos-section banquet-apply-people-infos-section-meat"
      >
        <div class="banquet-apply-title banquet-section-title">葷食</div>
        <radioButton
          :options="calculateTypes"
          v-model="info.calculateTypeOfMeat"
        ></radioButton>
        <inputField
          id="numberOfPeople"
          :label="countTitleMeat"
          placeholder="請輸入"
          inputType="number"
          maxLength="3"
          class="banquet-count"
          :value="displayInfo.numberOfPeople"
          @onInput="onInput"
          :errorText="errorText.numberOfPeople"
        />
      </div>
      <div
        class="banquet-apply-people-infos-section banquet-apply-people-infos-section-vegetable"
      >
        <div class="banquet-apply-title banquet-section-title">素食</div>
        <radioButton
          :options="calculateTypes"
          v-model="info.calculateTypeOfVegetable"
        ></radioButton>
        <inputField
          id="numberOfVegetarian"
          :label="countTitleVegetable"
          placeholder="請輸入"
          inputType="number"
          maxLength="3"
          class="banquet-count"
          :value="displayInfo.numberOfVegetarian"
          @onInput="onInput"
          :errorText="errorText.numberOfVegetarian"
        />
      </div>
    </div>
    <div>
      {{ `葷食共${headQuantityMeat}人` }}，{{
        `素食共${headQuantityVegetable}人`
      }}，{{ `總共${headQuantity}人` }} <br />
      <br />
      注意事項： <br />
      一桌十人，葷素不可在同一桌，不足一桌者將由現場工作人員進行併桌。
    </div>
    <div class="banquet-footer-steps">
      <div
        class="temple-button-text banquet-footer-previous"
        @click="previousClick"
      >
        上一步
      </div>
      <div class="temple-button-text banquet-footer-next" @click="nextClick">
        下一步
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import store from 'Store/store';
import inputField from 'Components/inputField/inputField.vue';
import { BFormRadioGroup, BFormRadio } from 'bootstrap-vue';
import validation from 'Core/validation.js';
import radioButton from 'Components/button/radioButton.vue';
import scrollToElement from 'scroll-to-element';

Vue.component('b-form-group', BFormRadioGroup);
Vue.component('b-form-radio', BFormRadio);

export default {
  name: 'ServiceBanquetStep2',
  components: {
    inputField,
    radioButton,
  },
  data() {
    return {
      info: {
        name: '',
        phone: '',
        calculateTypeOfMeat: '',
        calculateTypeOfVegetable: '',
        numberOfPeople: '',
        numberOfVegetarian: '',
      },
      errorText: {
        name: '',
        phone: '',
        calculateTypeOfMeat: '',
        calculateTypeOfVegetable: '',
        numberOfPeople: '',
        numberOfVegetarian: '',
      },
      calculateTypes: [
        { text: '申請桌數', value: 'desk' },
        { text: '申請人數', value: 'people' },
      ],
    };
  },
  beforeMount() {
    this.info = this.applyInfo;
  },
  methods: {
    previousClick() {
      this.$emit('previousStep');
    },
    nextClick() {
      this.validateFormat() && this.validateLogic() && this.goNextStep();
    },
    goNextStep() {
      store.dispatch('main/modifyBanquetApplyInfo', this.info);
      this.$emit('nextStep');
    },
    onInput(inputValue) {
      Object.assign(this.info, inputValue);
    },
    // 參數格式是否正確
    validateFormat() {
      Object.keys(this.info).forEach((element) => {
        if (this.info[element] === '') {
          this.errorText[element] = '必填';
        } else if (!validation[element].regex.test(this.info[element])) {
          this.errorText[element] = validation[element].msg;
        } else {
          this.errorText[element] = '';
        }
      });
      return this.checkError();
    },
    // 商業邏輯是否正確
    validateLogic() {
      if (this.headQuantity <= 0) {
        this.errorText.numberOfPeople = '總人數需大於0';
        this.errorText.numberOfVegetarian = '總人數需大於0';
        return this.checkError();
      }

      this.errorText.numberOfPeople = '';
      // let vCount = Number(this.info.numberOfVegetarian);
      let pCount =
        this.info.calculateType === 'desk'
          ? Number(this.info.numberOfPeople) * 10
          : Number(this.info.numberOfPeople);

      if (pCount > store.state.main.onlineStatus.reposeInfo.remainingAmount) {
        this.errorText.numberOfPeople = '平安宴剩餘座位不足，請調整人數';
        return this.checkError();
      }

      // this.errorText.numberOfVegetarian =
      //   vCount > pCount ? '吃素人數大於總人數' : '';
      return this.checkError();
    },
    // 確認有無error
    checkError() {
      let validateResult = true;
      let scrollFirstElement = true;
      Object.keys(this.errorText).forEach((element) => {
        if (this.errorText[element] !== '') {
          if (scrollFirstElement) {
            scrollToElement(`#${element}`, {
              offset: window.innerWidth < 768 ? -100 : -190,
              ease: 'out-circ',
              duration: 500,
            });
            scrollFirstElement = false;
          }
          validateResult = false;
        }
      });
      return validateResult;
    },
  },
  computed: {
    countTitleMeat() {
      return this.info.calculateTypeOfMeat == 'desk' ? '桌數' : '人數';
    },
    countTitleVegetable() {
      return this.info.calculateTypeOfVegetable == 'desk' ? '桌數' : '人數';
    },
    headQuantityMeat() {
      let pCount =
        this.applyInfo.calculateTypeOfMeat === 'desk'
          ? Number(this.applyInfo.numberOfPeople) * 10
          : Number(this.applyInfo.numberOfPeople);
      return pCount;
    },
    headQuantityVegetable() {
      let pCount =
        this.applyInfo.calculateTypeOfVegetable === 'desk'
          ? Number(this.applyInfo.numberOfVegetarian) * 10
          : Number(this.applyInfo.numberOfVegetarian);
      return pCount;
    },
    headQuantity() {
      return this.headQuantityMeat + this.headQuantityVegetable;
    },
    displayInfo() {
      return this.applyInfo;
    },
    applyInfo() {
      return store.state.main.banquetApplyInfo;
    },
  },
};
</script>

<style scoped>
.banquet-apply-people-infos {
  width: 100%;
}

.banquet-apply-people-infos-section {
  width: 100%;
}

.banquet-section-title {
  font-size: 16px;
  font-weight: bold;
  color: #b18147;
}

.banquet-apply-title {
  margin-top: 20px;
  margin-bottom: 10px;
}

.banquet-apply-people-infos-section >>> .radio-group {
  min-height: 30px;
}

.banquet-apply {
  margin: 0px 5px 0px 5px;
}

.banquet-name {
  margin-top: 50px;
}

.banquet-phone {
  margin-top: 10px;
}

.banquet-footer-steps {
  margin-top: 50px;
  align-items: center;
  display: flex;
  justify-content: center;
}

.banquet-footer-previous {
  margin-right: 15px;
}

.banquet-footer-next {
  margin-left: 15px;
}

@media (min-width: 768px) {
  .banquet-apply-people-infos {
    height: 300px;
  }

  .banquet-apply-people-infos-section {
    width: calc(50% - 20px);
  }

  .banquet-apply-people-infos-section-meat {
    float: left;
  }

  .banquet-apply-people-infos-section-vegetable {
    float: right;
  }

  .banquet-name,
  .banquet-phone {
    width: calc(50% - 20px);
  }

  .banquet-name {
    float: left;
  }

  .banquet-phone {
    float: right;
  }

  .banquet-phone {
    margin-top: 50px;
  }

  .banquet-footer-steps {
    margin-top: 40px;
  }
}
</style>
